export default __webpack_public_path__ + "static/media/Air Pollution 63d753e2ace345cc8d3f852f7796333d.60609c0f.md";